export default
{
    name: 'app-text-mask',

    props:
    {
        to: {type: String},
        href: {type: String},

        text: {type: String},
        classDefault: {type: String, default: ''},
        classOver: {type: String, default: 'u-color--red'},
        type: {type: String, default: 'router-link'}
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-text-mask/script.js